var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('List',{attrs:{"data":_vm.list,"has-more":_vm.hasMore,"empty-content":_vm.emptyContent},on:{"load-more":_vm.handleLoadMore}})}
var staticRenderFns = []

export { render, staticRenderFns }